import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-73acee0d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "message-btns" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon icon-group-add" }, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon icon-user-invite" }, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spacer" }, null, -1))
const _hoisted_6 = {
  key: 1,
  class: "scroller"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spacer" }, null, -1))
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { class: "message-btns" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon icon-group-add" }, null, -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon icon-user-invite" }, null, -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spacer" }, null, -1))
const _hoisted_14 = {
  key: 1,
  class: "scroller"
}
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spacer" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_spaces_invitations = _resolveComponent("spaces-invitations")!
  const _component_spaces_my_groups = _resolveComponent("spaces-my-groups")!
  const _component_spaces_outcoming = _resolveComponent("spaces-outcoming")!
  const _component_refresh_pull = _resolveComponent("refresh-pull")!
  const _component_spaces_group = _resolveComponent("spaces-group")!
  const _component_app_item_wrapper = _resolveComponent("app-item-wrapper")!
  const _component_message_group_chat_info = _resolveComponent("message-group-chat-info")!
  const _component_app_no_message = _resolveComponent("app-no-message")!

  return (_ctx.mainStore.isMobile)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (!_ctx.spacesStore.search)
          ? (_openBlock(), _createBlock(_component_refresh_pull, {
              key: 0,
              modelValue: _ctx.loadingPull,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.loadingPull) = $event)),
              onRefresh: _ctx.onRefresh,
              successText: _ctx.successText,
              pullingText: _ctx.pullingText,
              loosingText: _ctx.loosingText,
              loadingText: _ctx.loadingText
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", null, [
                  _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", {
                      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.createGroup && _ctx.createGroup(...args))),
                      class: "group-chat-create"
                    }, [
                      _hoisted_3,
                      _createElementVNode("p", null, _toDisplayString(_ctx.$localize('messages.create.group')), 1)
                    ]),
                    (_ctx.mainStore.isNative)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 0,
                          class: "tell-a-friend",
                          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.shareApp && _ctx.shareApp(...args)))
                        }, [
                          _hoisted_4,
                          _createElementVNode("p", null, _toDisplayString(_ctx.$localize('app.menu.share_app')), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  (_ctx.isManageContacts && _ctx.filteredInvitationsAndRequest.length)
                    ? (_openBlock(), _createBlock(_component_spaces_invitations, {
                        key: 0,
                        invitations: _ctx.filteredInvitationsAndRequest,
                        onOpenGroup: _ctx.openGroupInfo
                      }, null, 8, ["invitations", "onOpenGroup"]))
                    : _createCommentVNode("", true),
                  (_ctx.myGroups)
                    ? (_openBlock(), _createBlock(_component_spaces_my_groups, {
                        key: 1,
                        onOpenGroup: _ctx.openGroupInfo
                      }, null, 8, ["onOpenGroup"]))
                    : _createCommentVNode("", true),
                  (_ctx.isManageContacts && _ctx.spacesStore.filteredOutgoingGroup.length)
                    ? (_openBlock(), _createBlock(_component_spaces_outcoming, {
                        key: 2,
                        "outgoing-list": _ctx.spacesStore.filteredOutgoingGroup,
                        "custom-title": "groups.outcoming.title",
                        onOpenGroup: _ctx.openGroupInfo
                      }, null, 8, ["outgoing-list", "onOpenGroup"]))
                    : _createCommentVNode("", true),
                  _hoisted_5
                ])
              ]),
              _: 1
            }, 8, ["modelValue", "onRefresh", "successText", "pullingText", "loosingText", "loadingText"]))
          : (_openBlock(), _createElementBlock("div", _hoisted_6, [
              (_ctx.myGroupsSearch.length)
                ? (_openBlock(), _createBlock(_component_app_item_wrapper, { key: 0 }, {
                    title: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$localize('groups.my')), 1)
                    ]),
                    main: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.myGroupsSearch, (group) => {
                        return (_openBlock(), _createBlock(_component_spaces_group, {
                          key: group?.id,
                          group: group,
                          groupType: _ctx.NETWORK_CONTACT_TYPES.MY,
                          onOpenGroup: _ctx.openGroupInfo
                        }, null, 8, ["group", "groupType", "onOpenGroup"]))
                      }), 128))
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_ctx.publicGroupsSearch.length)
                ? (_openBlock(), _createBlock(_component_app_item_wrapper, { key: 1 }, {
                    title: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$localize('groups.public')), 1)
                    ]),
                    main: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.publicGroupsSearch, (group) => {
                        return (_openBlock(), _createBlock(_component_spaces_group, {
                          key: group?.id,
                          group: group,
                          groupType: group.groupStatus === _ctx.CONTACT_STATUS.PENDING
                          ? _ctx.NETWORK_CONTACT_TYPES.OUTCOMING
                          : _ctx.NETWORK_CONTACT_TYPES.SUGGESTION,
                          onOpenGroup: _ctx.openGroupInfo
                        }, null, 8, ["group", "groupType", "onOpenGroup"]))
                      }), 128))
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              _hoisted_7
            ])),
        (_ctx.isGroupInfo)
          ? (_openBlock(), _createBlock(_component_message_group_chat_info, {
              key: 2,
              onClose: _ctx.closeGroupInfo
            }, null, 8, ["onClose"]))
          : _createCommentVNode("", true),
        _withDirectives(_createVNode(_component_app_no_message, {
          icon: _ctx.noDataMessage.icon,
          class: "no-data-message"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.noDataMessage.text), 1)
          ]),
          _: 1
        }, 8, ["icon"]), [
          [_vShow, !_ctx.spacesStore.dataLoading && _ctx.noData]
        ])
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_8, [
        (!_ctx.spacesStore.search)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", {
                  onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.createGroup && _ctx.createGroup(...args))),
                  class: "group-chat-create"
                }, [
                  _hoisted_11,
                  _createElementVNode("p", null, _toDisplayString(_ctx.$localize('messages.create.group')), 1)
                ]),
                (_ctx.mainStore.isNative)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: "tell-a-friend",
                      onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.shareApp && _ctx.shareApp(...args)))
                    }, [
                      _hoisted_12,
                      _createElementVNode("p", null, _toDisplayString(_ctx.$localize('app.menu.share_app')), 1)
                    ]))
                  : _createCommentVNode("", true)
              ]),
              (_ctx.isManageContacts && _ctx.filteredInvitationsAndRequest.length)
                ? (_openBlock(), _createBlock(_component_spaces_invitations, {
                    key: 0,
                    invitations: _ctx.filteredInvitationsAndRequest
                  }, null, 8, ["invitations"]))
                : _createCommentVNode("", true),
              (_ctx.myGroups)
                ? (_openBlock(), _createBlock(_component_spaces_my_groups, {
                    key: 1,
                    onOpenGroup: _ctx.openGroupInfo
                  }, null, 8, ["onOpenGroup"]))
                : _createCommentVNode("", true),
              (_ctx.isManageContacts && _ctx.spacesStore.filteredOutgoingGroup.length)
                ? (_openBlock(), _createBlock(_component_spaces_outcoming, {
                    key: 2,
                    "outgoing-list": _ctx.spacesStore.filteredOutgoingGroup,
                    "custom-title": "groups.outcoming.title",
                    onOpenGroup: _ctx.openGroupInfo
                  }, null, 8, ["outgoing-list", "onOpenGroup"]))
                : _createCommentVNode("", true),
              _hoisted_13
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_14, [
              (_ctx.myGroupsSearch.length)
                ? (_openBlock(), _createBlock(_component_app_item_wrapper, { key: 0 }, {
                    title: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$localize('groups.my')), 1)
                    ]),
                    main: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.myGroupsSearch, (group) => {
                        return (_openBlock(), _createBlock(_component_spaces_group, {
                          key: group?.id,
                          group: group,
                          groupType: _ctx.NETWORK_CONTACT_TYPES.MY,
                          onOpenGroup: _ctx.openGroupInfo
                        }, null, 8, ["group", "groupType", "onOpenGroup"]))
                      }), 128))
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_ctx.publicGroupsSearch.length)
                ? (_openBlock(), _createBlock(_component_app_item_wrapper, { key: 1 }, {
                    title: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$localize('groups.public')), 1)
                    ]),
                    main: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.publicGroupsSearch, (group) => {
                        return (_openBlock(), _createBlock(_component_spaces_group, {
                          key: group?.id,
                          group: group,
                          groupType: group.groupStatus === _ctx.CONTACT_STATUS.PENDING
                          ? _ctx.NETWORK_CONTACT_TYPES.OUTCOMING
                          : _ctx.NETWORK_CONTACT_TYPES.SUGGESTION,
                          onOpenGroup: _ctx.openGroupInfo
                        }, null, 8, ["group", "groupType", "onOpenGroup"]))
                      }), 128))
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              _hoisted_15
            ])),
        (_ctx.isGroupInfo)
          ? (_openBlock(), _createBlock(_component_message_group_chat_info, {
              key: 2,
              onClose: _ctx.closeGroupInfo
            }, null, 8, ["onClose"]))
          : _createCommentVNode("", true)
      ]))
}